"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateNursingStationSchema = exports.createNursingStationSchema = exports.nursingStationShape = void 0;
const zod_1 = require("zod");
// Hospital Infrastructure — Nursing Station Master, an optional grouping
// tier under Ward. See `ward.schema.ts` for the sibling masters.
exports.nursingStationShape = {
    wardId: zod_1.z.string().uuid(),
    code: zod_1.z.string().min(1).max(30),
    name: zod_1.z.string().min(1).max(150),
    displayOrder: zod_1.z.number().int().min(0).optional(),
    isActive: zod_1.z.boolean().optional(),
};
exports.createNursingStationSchema = zod_1.z.object(exports.nursingStationShape);
exports.updateNursingStationSchema = exports.createNursingStationSchema.partial();
//# sourceMappingURL=nursing-station.schema.js.map